import { render } from "./LayoutView.vue?vue&type=template&id=70eb6c20"
import script from "./LayoutView.vue?vue&type=script&lang=js"
export * from "./LayoutView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__